import service from '@/services/superaccess'

const company = {
  state: {
    company_modal: false
  },
  mutations: {
    updateStatusCompanyModal (state, status) {
      state.company_modal = status
    }
  },
  getters: {
    getStatusCompanyModal (context) {
      return context.company_modal
    }
  },
  actions: {
    retriveCompanyTypes (context, payload) {
      return service.get('/api/companies/types', context)
    },
    saveCompany (context, payload) {
      return service.post('/api/company/create', context, { company: payload })
    },
    updateCompany (context, payload) {
      return service.patch('/api/company/modify', context, { company: payload })
    },
    changeCompanyStatus (context, payload) {
      return service.patch('/api/company/inactive', context, payload)
    },
    setStatusCompanyModal (context, payload) {
      context.commit('updateStatusCompanyModal', payload)
    },
    retriveCPointsCompany (context, payload) {
      return service.post('/api/company/control_points', context, { company_id: payload })
    },
    checkCompany (context, payload) {
      return service.post('/api/company/check', context, { company_id: payload })
    },
    retriveCompany (context, payload) {
      return service.post('/api/company/list', context)
    },
    CompanyAuthorizationCount(context, payload) {
      return service.post('/api/company_authorization_count', context)
    }
  }
}

export default company



// WEBPACK FOOTER //
// app/javascript/src/store/company.js